// extracted by mini-css-extract-plugin
export var facebookCustom = "SocialShareButtons-module--facebookCustom--c9b57";
export var pinterestCustom = "SocialShareButtons-module--pinterestCustom--7aece";
export var shareButtonsContainerCustom = "SocialShareButtons-module--shareButtonsContainerCustom--09bb6";
export var socialIShareButtonsContainerCustom = "SocialShareButtons-module--socialIShareButtonsContainerCustom--e0333";
export var socialMediaLinkCustom = "SocialShareButtons-module--socialMediaLinkCustom--337d9";
export var socialshareButtonsPlainCustom = "SocialShareButtons-module--socialshareButtonsPlainCustom--8c68f";
export var twitterCustom = "SocialShareButtons-module--twitterCustom--a7543";